import { Storybook } from "@tento-ui/ui/storybook";
import { TurnNote } from "./note";

export class TurnNoteStoryBook extends Storybook.Default {
  title(): string {
    return "Turn · note (two faces)";
  }

  examples(): Storybook.Example[] {
    return [
      {
        title: "text[active] — the line that says it is still working",
        render: () =>
          TurnNote.makeWith({
            face: "text",
            text: "Distilling the transcript…",
            active: true,
          }),
      },
      {
        title: "The two side by side — live, then settled",
        render: () => {
          const $wrap = column();
          $wrap.append(
            TurnNote.makeWith({
              face: "text",
              text: "Reading 41 files…",
              active: true,
            }),
            TurnNote.makeWith({
              face: "text",
              text: "session · commands · 57",
            }),
          );
          return $wrap;
        },
      },
      {
        title: "text — a session meta event, which is not working on anything",
        render: () =>
          TurnNote.makeWith({ face: "text", text: "mode: plan · model opus" }),
      },
      {
        title: "text — a long line ellipsizes rather than wrapping",
        render: () =>
          TurnNote.makeWith({
            face: "text",
            text:
              "Compacting the context window — 41 messages coalesced into one summary, retaining the last 8 turns verbatim and every unresolved verdict",
            active: true,
          }),
      },
      {
        title: "rule — a bare divider",
        render: () => TurnNote.makeWith({ face: "rule" }),
      },
      {
        title: "rule — labelled",
        render: () => TurnNote.makeWith({ face: "rule", label: "final message" }),
      },
    ];
  }
}

function column(): HTMLElement {
  const $wrap = document.createElement("div");
  $wrap.style.display = "flex";
  $wrap.style.flexDirection = "column";
  $wrap.style.gap = "8px";
  $wrap.style.width = "100%";
  return $wrap;
}
